import {Component, Input, OnInit} from '@angular/core';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';

@Component({
  selector: 'app-read-message',
  templateUrl: './read-message.component.html',
  styleUrls: ['./read-message.component.css']
})
export class ReadMessageComponent extends GeneralExerciseComponent {

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    this.solved = false;
  }

  checkSolution() {
    if (this.solved) {
      this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
      this.isSolvedImageVisible = true;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
    }
  }

  generateNextExercise() {
    this.counter ++;
    this.initValues();
  }

  setSolved(solved: boolean) {
    this.solved = solved;
    this.checkSolution();
  }

  setTypeSpecificsFromConfiguration() {
  }

  setTypeSpecificsFromState() {
  }

  computeState() {
  }
}
